export const DEFAULT_CRM_TOKEN = 'bplzyzvu967';
export const CRM_APP_IFRAME_URL = 'https://agency.comcate.com/';
export const brandLogo = `${window.assetsLocation}/images/logo.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/logo.png`;
export const textLogoUrl = `${window.assetsLocation}/images/text_logo.png`;
export const secondaryLogoUrl = `${window.assetsLocation}/images/logo_.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.png`;
export const bannerMobileUrl = `${window.assetsLocation}/images/banner_2.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['15'];
export const faqArticleIds = ['16', '17', '18', '19', '20', '21', '22', '23', '24'];
